<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>Get involved</h1>
        </div>
    </section>
  </div>

  <section class="section">

        <div class="container">
            <h2 class="subheader">Interested in joining in?</h2>

            <div class="columns">
                
                <div class="column">
                    <a href="/auditions">
                        <div class="card match-height">
                          <div class="card-content match-content-height">
                            <div class="content">
                                <p class="title">
                                    Auditions
                                </p>
                                <p>We are always thrilled to welcome both new and old friends to audition for our upcoming productions.</p>
                                <p>Find out all the details for any auditions we have coming up.</p>
                            </div>
                          </div>
                          <footer class="card-content">
                            <router-link :to="{name: 'auditions'}">Auditions</router-link>
                          </footer>
                        </div>
                    </a>
                </div>

                <div class="column">
                    <a href="/director-submissions/">
                        <div class="card match-height">
                          <div class="card-content match-content-height">
                            <div class="content">
                                <p class="title">
                                    Director submissions
                                </p>
                                <p>We'd love to hear from you.</p>
                                <p>We are always open to director submissions.</p>
                            </div>
                          </div>
                          <footer class="card-content">
                            <router-link :to="{name: 'directorsubmissions'}">Director submissions</router-link>
                          </footer>
                        </div>
                    </a>
                </div>

                <div class="column">
                    <a href="/backstage-crew">
                        <div class="card match-height">
                          <div class="card-content match-content-height">
                            <div class="content">
                                <p class="title">
                                    Backstage crew
                                </p>
                                <p>One of the best ways to get involved back stage is to join The Penguin Club.</p>
                                <p>The Penguin Club exists to provide backstage support to amateur societies in and around Cambridge.</p>
                            </div>
                          </div>
                          <footer class="card-content">
                            <router-link :to="{name: 'backstagecrew'}">Backstage crew</router-link>
                          </footer>
                        </div>
                    </a>
                </div>
            </div>



            <!-- <h2 class="subtitle"><router-link tag="a" :to="{name: 'products', params: {}}">Hot products</router-link></h2>
            <ProductCards :items="products" /> -->
        </div>

    </section>

    <div class="grey-block">
        <div class="container has-text-centered content">
            <h3 class="title block-with-medium-vertical-gap">Keep up-to-date with the latest AmDram scene in Cambridge</h3>
            <p>The Combinations newsletter is the unmissable amateur drama monthly newsletter published by Combined Actors of Cambridge.</p>
            <div class="block-with-small-vertical-gap">
                <div class="control has-text-centered">
                    <router-link :to="{name: 'combinations'}" class="button is-link is-medium">Combinations newsletter</router-link>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
//import ProductCards from './cards/ProductCards';
import Api from '@/config/Api'

export default {
    /* components: {
        ProductCards
    }, */
    data() {
        return {
            //plays: [],
        }
    },
    /* computed: {
        country() {
            return this.$store.getters.getCountry
        }
    }, */
    created() {
        /*Api().get(`/api/plays/whatson`).then(response => {
            this.plays = response.data;
            console.log("whatson created", this.plays);
        });*/
        this.$store.commit('setContentLoaded', true); // then footer will be displayed
    },
    methods: {
        /*checkPage(url) {
            Api().get(url).then(response => {
                console.log("checkPage url:",url);
                this.products = response.data.products;
                this.currentPage = response.data.currentPage;
                this.pages = response.data.pages;
                this.nextUrl = response.data.nextUrl;
                this.prevUrl = response.data.prevUrl;
            })
        }*/
    },
    metaInfo: {
      title: "Get involved",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Getinvolved.vue